<template>
  <span v-html="parsedContent"></span>
</template>

<script>
export default {
  props: { content: { type: String, default: '' } },
  computed: {
    parsedContent() {
      let result = this.content
                  // Replace octal literals
                  .replace(/\\(\d{3})/g, (match, p1) => String.fromCharCode(parseInt(p1, 8)))
                  // .replace(/"/g, '\'')
                  // Replace new lines with <br/>
                  .replace(/(\r\n|\n|\r)/g, '<br/>')
                  .replace(/\s+/g, ' ')
                  // replace question marks to dashes when emoji is not recognised
                  .replace('????', '--').replace('??', '--')
                  // Replace double quotes in iframe tags attributes
                  .replace(/<iframe(.+)<\/iframe>/g, match => match.replace(/"/g, '\''));
                  // .replace(/\\ /g, '\\');

      var a = result.split(" "), i;
      result = '';
      for (i = 0; i < a.length; i++) {
        if(!a[i].includes('\\u')){
          a[i] = a[i].replace(/\\/g, '-=-=-');
        }
        result += ' ' + a[i];
      }

      try{
        result = window.twemoji.parse(JSON.parse(`"${result}"`));
      }
      catch (e) {
        return result = result.replace(/-=-=-/g, '\\');
      }

      return result = result.replace(/-=-=-/g, '\\');
    },
  },
};
</script>

<style lang="scss">
// size the emoji according to the surrounding text
img.emoji {
   height: 1em;
   width: 1em;
   margin: 0 .05em 0 .1em;
   vertical-align: -0.1em;
}
</style>



// WEBPACK FOOTER //
// src/components/Messages/Twemoji.vue